import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {BillingMode} from 'ApplicationEntry/sagas/billingAgentSaga';

export class UnvalidatedBillingModes {
  public readonly key = 'UnvalidatedBillingModes';

  constructor(public readonly billingModes: BillingMode[]) {}
}

export class InvalidBillingModes {
  public readonly key = 'InvalidBillingModes';

  constructor(public readonly billingModes: BillingMode[]) {}
}

type AppProps = {
  billingModes: BillingMode[];
};

export class ValidBillingModes {
  public static createFromApp({billingModes}: AppProps) {
    return this.create(billingModes);
  }

  public static create(billingModes: BillingMode[]) {
    return billingModes.length > 0 ? new ValidBillingModes(billingModes) : new InvalidBillingModes(billingModes);
  }

  public readonly key = 'ValidBillingModes';
  private constructor(public readonly billingModes: BillingMode[]) {}
}

export type BillingModes = UnvalidatedBillingModes | InvalidBillingModes | ValidBillingModes;

export type BillingModesOptions<TReturn> = ToPartialMatchOptions<BillingModes, 'key', TReturn>;

export const matchBillingModes = <TReturn>(options: BillingModesOptions<TReturn>) => (app: BillingModes): TReturn => {
  switch (app.key) {
    case 'InvalidBillingModes':
      return options.InvalidBillingModes ? options.InvalidBillingModes(app) : options.default(app);
    case 'UnvalidatedBillingModes':
      return options.UnvalidatedBillingModes ? options.UnvalidatedBillingModes(app) : options.default(app);
    case 'ValidBillingModes':
      return options.ValidBillingModes ? options.ValidBillingModes(app) : options.default(app);
  }
};

export const changeBillingModes = (billingModeList: BillingMode[]) => (app: BillingModes) =>
  ValidBillingModes.createFromApp({
    ...app,
    billingModes: billingModeList,
  });

export const EmptyBillingModes = new UnvalidatedBillingModes([]);
